module.exports = __webpack_public_path__ + "img/searchempty.decd30f7.jpg";